module.exports = __webpack_public_path__ + "img/ill-home-slider-1.4cd10edc.gif";